import React__default, { useState } from 'react';
import { useRouter } from 'next/router';
import Styles from './CustomLoader.module.scss.js';

const CustomLoader = ({ enable = false }) => {
    const router = useRouter();
    /**
     * Loader
     */
    const [isLoading, setIsLoading] = useState(false);
    router.events.on("routeChangeStart", (url) => {
        setIsLoading(true);
    });
    router.events.on("routeChangeComplete", () => {
        setIsLoading(false);
    });
    router.events.on("routeChangeError", () => {
        setIsLoading(false);
    });
    if (!enable && !isLoading)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement("div", { className: Styles.wrapper },
        React__default.createElement("div", { className: Styles.spinner },
            React__default.createElement("div", { className: Styles.doubleBounce1 }),
            React__default.createElement("div", { className: Styles.doubleBounce2 }))));
};

export { CustomLoader as default };
//# sourceMappingURL=CustomLoader.js.map
